export default {"id":"18822f78","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}